var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cat--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.43,342s-21.87,7.93-26,21.63S162.26,412,162.26,412s-9.8,6.43-10.7,9,4,6.67,4,6.67-.18,3.06,3.42,5.41,8.48,0,8.48,0a15.31,15.31,0,0,0,7.93,1.8c4.68-.18,14.78-11.72,15.86-13.52S170.43,342,170.43,342Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,354.69a29.82,29.82,0,0,0-6.34,7.38,33.56,33.56,0,0,0-2.16,4.43,19.92,19.92,0,0,0-1.39,4.65c-.13.93-.28,1.85-.38,2.79a8.39,8.39,0,0,0,0,2.5c0,.07.11.07.14,0a5.93,5.93,0,0,0,.4-1.3c.13-.5.3-1,.46-1.48.3-.93.66-1.83,1-2.74a52.24,52.24,0,0,1,2.34-5.58c.89-1.78,1.94-3.47,3-5.17a35.81,35.81,0,0,1,3.59-4.9A.43.43,0,0,0,150.68,354.69Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,362.87a21.82,21.82,0,0,0-1.53,1.92,17.22,17.22,0,0,0-1.11,2,18.68,18.68,0,0,0-1.49,4.61,21.49,21.49,0,0,0,.16,9.64.15.15,0,0,0,.3,0h0c.28-1.5.39-3,.59-4.56s.39-3,.7-4.53a41.63,41.63,0,0,1,1.18-4.38,20.08,20.08,0,0,1,1.89-4.2A.44.44,0,0,0,147.17,362.87Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.43,342s-21.87,7.93-26,21.63S162.26,412,162.26,412s-9.8,6.43-10.7,9,4,6.67,4,6.67-.18,3.06,3.42,5.41,8.48,0,8.48,0a15.31,15.31,0,0,0,7.93,1.8c4.68-.18,14.78-11.72,15.86-13.52S170.43,342,170.43,342Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.68,354.69a29.82,29.82,0,0,0-6.34,7.38,33.56,33.56,0,0,0-2.16,4.43,19.92,19.92,0,0,0-1.39,4.65c-.13.93-.28,1.85-.38,2.79a8.39,8.39,0,0,0,0,2.5c0,.07.11.07.14,0a5.93,5.93,0,0,0,.4-1.3c.13-.5.3-1,.46-1.48.3-.93.66-1.83,1-2.74a52.24,52.24,0,0,1,2.34-5.58c.89-1.78,1.94-3.47,3-5.17a35.81,35.81,0,0,1,3.59-4.9A.43.43,0,0,0,150.68,354.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.17,362.87a21.82,21.82,0,0,0-1.53,1.92,17.22,17.22,0,0,0-1.11,2,18.68,18.68,0,0,0-1.49,4.61,21.49,21.49,0,0,0,.16,9.64.15.15,0,0,0,.3,0h0c.28-1.5.39-3,.59-4.56s.39-3,.7-4.53a41.63,41.63,0,0,1,1.18-4.38,20.08,20.08,0,0,1,1.89-4.2A.44.44,0,0,0,147.17,362.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M191.22,421.26c-1.08,1.81-11.18,13.35-15.86,13.52a15.29,15.29,0,0,1-7.94-1.8s-4.87,2.35-8.46,0-3.43-5.41-3.43-5.41-4.87-4.14-4-6.66,10.7-9,10.7-9c5.28-.9,11.05,1.15,11.05,1.15a20.59,20.59,0,0,0-8.19-2.06,21.29,21.29,0,0,1,12.35,2.06,48,48,0,0,0,13.12,4C191.12,419.54,191.36,421,191.22,421.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.22,421.26c-1.08,1.81-11.18,13.35-15.86,13.52a15.76,15.76,0,0,1-5.19-.67l10.38-19.64a54.21,54.21,0,0,0,10,2.64C191.12,419.54,191.36,421,191.22,421.26Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.75,415.53a23.44,23.44,0,0,0-2.71,2.25,12.14,12.14,0,0,0-2.38,2.87c-1.16,2.15-.5,4.67-.21,7,0,.1.16.09.15,0a10.67,10.67,0,0,1,1-6.56,26.56,26.56,0,0,1,4.28-5.34C161,415.61,160.85,415.46,160.75,415.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.8,419.71a22,22,0,0,0-5.43,5.59,9.27,9.27,0,0,0-1.23,3.5,10.39,10.39,0,0,0,.44,4c0,.07.13.07.14,0,.18-1.25.29-2.51.56-3.75a13.31,13.31,0,0,1,1.25-3.26,20.29,20.29,0,0,1,1.89-3c.78-1,1.65-2,2.47-3C173.94,419.77,173.87,419.66,173.8,419.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.06,214c-3.55.48-10.74-50.47,1.5-67.22,1.76-2.41,39,15.44,39.55,16.75S149.37,213,142.06,214Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,163.49c.18.41-3.05,5.4-7.78,12.08-8-13.13-31.07-27.35-31.64-27s-4.37,14.31-4.78,29.5c-.47,18,3.5,30.06,5.42,34.79a5.66,5.66,0,0,1-2.27,1.11c-3.54.48-10.73-50.47,1.51-67.23C145.32,144.33,182.54,162.18,183.11,163.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.55,208.92a46.84,46.84,0,0,0-1.19-4.7,42.1,42.1,0,0,0-1.63-4.53,35.14,35.14,0,0,0-4.79-8.25,23.14,23.14,0,0,0-3.29-3.42c-.59-.53-1.24-1-1.88-1.46s-1.33-.86-2-1.22a21.36,21.36,0,0,0-2.16-1c-.75-.25-1.49-.57-2.27-.75a28,28,0,0,0-4.74-.92,21.09,21.09,0,0,1,9.51,2,21.5,21.5,0,0,1,7.64,6.17,30.41,30.41,0,0,1,4.72,8.59A35.47,35.47,0,0,1,153.55,208.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.7,207.69a51.78,51.78,0,0,0-.67-6.93,59.38,59.38,0,0,0-1.46-6.79,50.23,50.23,0,0,0-5.39-12.71,43.38,43.38,0,0,0-4-5.62,45.06,45.06,0,0,0-4.91-4.86,39.16,39.16,0,0,0-5.65-4,50.37,50.37,0,0,0-6.22-3.15,40.25,40.25,0,0,1,12.36,6.54A39.73,39.73,0,0,1,149,180.75a47.51,47.51,0,0,1,5.28,13A48.81,48.81,0,0,1,155.7,207.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,222.54c3.34,1.26,21.87-46.73,13.74-65.83-1.16-2.74-41.46,6.22-42.31,7.38S266.43,219.93,273.33,222.54Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.77,164.09c-.27.35,1.74,5.94,4.84,13.52,10.79-11,36.45-19.61,36.93-19.15s1,14.93-2,29.82c-3.61,17.62-10.22,28.48-13.15,32.66a5.77,5.77,0,0,0,1.95,1.59c3.35,1.27,21.88-46.72,13.75-65.82C285.9,154,245.61,162.94,244.77,164.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.78,208.92a35.08,35.08,0,0,1,2.1-9.51,30.41,30.41,0,0,1,4.72-8.59,21.68,21.68,0,0,1,7.64-6.17,21.13,21.13,0,0,1,9.52-2,27.78,27.78,0,0,0-4.74.92c-.78.18-1.52.5-2.28.75a21.2,21.2,0,0,0-2.15,1c-.71.36-1.36.81-2,1.22s-1.29.93-1.87,1.46a23.21,23.21,0,0,0-3.3,3.42,35.14,35.14,0,0,0-4.79,8.25,50.61,50.61,0,0,0-2.81,9.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,207.69a48.47,48.47,0,0,1,1.4-13.92,47.8,47.8,0,0,1,5.27-13,39.76,39.76,0,0,1,9.28-10.57,40.2,40.2,0,0,1,12.35-6.54,50.24,50.24,0,0,0-6.21,3.15,39.26,39.26,0,0,0-5.66,4,44.1,44.1,0,0,0-4.9,4.86,42.44,42.44,0,0,0-4,5.62A49.52,49.52,0,0,0,273.76,194a55.39,55.39,0,0,0-1.46,6.79A51.79,51.79,0,0,0,271.62,207.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,238.85c0,6.6,8.23,25.59,25.24,38.93,0,0,6.42,84.08,7.83,90.94s19.34,58.92,19.28,59.64-7.76,7-8.76,9.1a19.41,19.41,0,0,0-1.39,5.68c0,.48,4.52,5.52,7.16,5.72,0,0,7.81,5.05,14.08,1.79,0,0,5.82,1.16,9,.08s10.75-8.35,13.47-10.79,1.81-7.28,1.81-7.28l18.87,1.43s1.17,8.46,2.31,11,8.68,7.89,11.65,8.47,8.08-1.67,8.08-1.67,5.3,1.6,9,1,6.23-5.79,6.23-5.79a21.6,21.6,0,0,0,5.66-3.19c1.94-1.78-2.6-8.63-5.25-10.28a12.17,12.17,0,0,0-4.92-1.82s52.64-1.32,62.85-2.48,20.52-3.51,22-6.77.56-67.93-2.87-76.87-21.76-34.18-28.34-39.5-41.66-38.82-41.66-38.82,14.89-19.4,16.64-32c.53-3.82-36.34-61.32-49.44-69.78s-63.29-4.27-69.37-.67C161,175.38,129.57,235.05,129.57,238.85Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,361.27c.17-1.79.38-3.59.66-5.38a.57.57,0,0,0-1.1-.27,36.66,36.66,0,0,0-1.36,5.34,39.32,39.32,0,0,0-.49,5.53c-.11,3.5-.11,7.39,1.56,10.57,0,.05.13,0,.14,0,.54-3.45.05-7,.17-10.49C162.67,364.78,162.86,363,163,361.27Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.7,349.08a23.26,23.26,0,0,0-4.5,9.71,25.79,25.79,0,0,0-.78,5.31,23.76,23.76,0,0,0,0,2.67,13.55,13.55,0,0,0,.61,2.59c0,.09.19.1.2,0,.13-.84.38-1.67.47-2.51s.16-1.65.28-2.47c.26-1.69.53-3.38,1-5.05a72.32,72.32,0,0,1,3.6-9.62C164.77,349.2,164.13,348.58,163.7,349.08Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.57,226.92a47.45,47.45,0,0,0-3.51,4.82,36,36,0,0,0-2.67,5.3,35.11,35.11,0,0,0-1.94,5.64,52.68,52.68,0,0,0-.85,6c0,.23.29.33.36.09.55-1.87,1.29-3.69,2-5.5s1.33-3.64,2.09-5.43,1.6-3.55,2.44-5.31,1.67-3.51,2.64-5.2C136.35,227,135.83,226.6,135.57,226.92Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44,234.66a31.84,31.84,0,0,0-2.31,5,30.83,30.83,0,0,0-1.29,5.26,29.79,29.79,0,0,0,.47,10.73.1.1,0,0,0,.19,0,59.9,59.9,0,0,1,.94-10.52,51.76,51.76,0,0,1,1.09-5.09,52.62,52.62,0,0,1,1.5-5.07C134.17,234.55,133.61,234.34,133.44,234.66Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.88,226.43a46.77,46.77,0,0,0-4.38-5.05c-.1-.11-.3,0-.21.17a64,64,0,0,1,6,10.1c.85,1.72,1.68,3.46,2.39,5.24s1.36,3.69,2,5.55c.75,2.09,1.31,4.24,1.92,6.37a.08.08,0,0,0,.15,0C300.83,240.76,297.65,232.79,292.88,226.43Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.33,246.08a21.85,21.85,0,0,0-.16-2.42,32.16,32.16,0,0,0-.86-4.88,58.22,58.22,0,0,0-3.56-9.19c-.08-.17-.37,0-.31.14,1,3.05,1.66,6.25,2.39,9.38.36,1.55.75,3.09,1.15,4.63.2.78.38,1.58.6,2.35s.34,1.59.61,2.34c0,.06.13.07.14,0A23,23,0,0,0,297.33,246.08Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.34,324.36c-1.47-1.91-2.9-3.84-4.4-5.71a51.56,51.56,0,0,0-4.91-5.22c-1.76-1.63-3.54-3.24-5.43-4.72s-4-2.78-6-4.13c-1.08-.74-2.23-1.38-3.35-2.07s-2.35-1.46-3.56-2.14c-.08-.05-.15.07-.07.13,2,1.4,3.9,2.81,5.75,4.36s3.56,3.07,5.32,4.63,3.58,3.08,5.32,4.67c.9.82,1.78,1.65,2.65,2.5s1.77,1.57,2.64,2.36c2,1.8,4,3.54,5.83,5.48C341.25,324.59,341.42,324.46,341.34,324.36Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,351.06a57.31,57.31,0,0,0-3-6.17c-1.08-2-2.25-4-3.49-6a49.88,49.88,0,0,0-4.12-5.39c-1.67-1.95-3.45-3.79-5.17-5.7-.06-.07-.16,0-.1.11,2.89,3.49,5,7.51,7.43,11.34,1.18,1.9,2.33,3.82,3.41,5.78s2,4,3,6c1.13,2.25,2.32,4.48,3.45,6.73.16.31.61.07.53-.24A47.22,47.22,0,0,0,355.09,351.06Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.12,361.25a31.6,31.6,0,0,0-1.5-5.12c-.62-1.61-1.34-3.16-2.11-4.7a39.8,39.8,0,0,0-2.65-4.72c-.05-.06-.17,0-.14.06.63,1.61,1.32,3.2,1.92,4.82s1.12,3.29,1.63,5,1,3.32,1.58,5,1,3.33,1.57,5a.2.2,0,0,0,.39-.07A28.18,28.18,0,0,0,356.12,361.25Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.63,180.14c-3.24,4.11-6.57,8.19-9.53,12.5s-5.76,8.81-8.3,13.39a79.06,79.06,0,0,0-4,8.08.1.1,0,0,0,.18.1c3-4.31,5.66-8.88,8.42-13.35s5.62-8.86,8.4-13.31c1.56-2.51,3.2-5,4.89-7.39C163.66,180.14,163.64,180.13,163.63,180.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.34,207c-2.92-4.53-5.76-9.09-8.91-13.47s-6.35-8.54-9.79-12.61c0,0-.12,0-.09.07,2.89,4.49,5.92,8.88,9,13.23s6.44,8.56,9.63,12.87A.08.08,0,0,0,281.34,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.15,333.66c-6.44-.47-12-4.86-14.66-9.93a18.27,18.27,0,0,1-2-6.47,6.2,6.2,0,0,0,1.55-.81,10.26,10.26,0,0,0,3-4.05,14.79,14.79,0,0,0,1.46-5.49c.06-1.38,0-3.66-1.67-4.31s-3,.89-3.57,2a22.18,22.18,0,0,0-1.77,5.28,23.4,23.4,0,0,0-.53,6.18,4.3,4.3,0,0,1-1.28-.06c-3.48-.65-5-3.88-5.37-6.72a33.42,33.42,0,0,1,.28-10,51.68,51.68,0,0,1,7.55-19.15c.46-.72.9-1.45,1.4-2.15.05-.08-.09-.15-.14-.07-4.59,6.38-8.49,13.16-10.15,20.66a31.27,31.27,0,0,0-.67,11.11c.48,3.39,2.36,6.93,6.41,7.75a6.41,6.41,0,0,0,2.09.09,20,20,0,0,0,.74,3.57,18.81,18.81,0,0,0,14.82,12.69,20.07,20.07,0,0,0,2.46.2C228.44,334.06,228.42,333.69,228.15,333.66ZM211.33,314a24.27,24.27,0,0,1,.62-5c.2-.84.44-1.68.72-2.51a7.24,7.24,0,0,1,1-2.15c.41-.52,1.22-1.3,2-.82s.71,1.45.75,2.11a11.69,11.69,0,0,1-1,5.09c-.75,1.77-2,4.1-4,5C211.34,315.16,211.32,314.58,211.33,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.15,388.22c-4-4.58-18.28-22.64-21.5-27.71-6.48-10.19-11.84-21.11-17.43-31.73-3.17-6-6.75-13.16-9.73-19.27-.05-.09-.21-.05-.17.05,4.82,11,8.6,21.65,13.27,31.66A157.82,157.82,0,0,0,206.12,372c4.26,5.39,10.92,11.51,15.82,16.42C222,388.47,222.24,388.33,222.15,388.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53,414c-.07-6.5-.4-13-.76-19.48-.2-3.69-.45-7.39-.59-11.08a.13.13,0,0,0-.26,0c0,6.5-.19,13-.23,19.51s.13,13,.43,19.48c.18,3.71.51,7.4.81,11.09a.14.14,0,0,0,.27,0c.12-3.25.31-6.5.34-9.76S218.56,417.25,218.53,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,425.18c0-3.19-.05-6.38-.17-9.57q-.34-9.57-.93-19.13c-.22-3.63-.52-7.27-.75-10.9a.2.2,0,0,0-.4,0c.07,6.38,0,12.76.19,19.14s.43,12.76.84,19.13c.11,1.8.23,3.59.38,5.38.07.86.15,1.71.22,2.56s.22,1.73.27,2.6a.09.09,0,0,0,.17,0,37.56,37.56,0,0,0,.18-4.38C236.38,428.42,236.37,426.8,236.36,425.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,377.84q1.1-8.18,2.31-16.32a.14.14,0,0,0-.28,0q-1.24,7.13-2.59,14.23c-.89,4.7-1.62,9.43-2.59,14.12a67.48,67.48,0,0,1-4.69,13.43c-1.93,4.38-3.85,8.77-5.69,13.2-1,2.49-2.08,5-3.09,7.48-.51,1.25-1,2.49-1.52,3.75s-.93,2.64-1.42,3.95a.14.14,0,0,0,.26.12c.56-1.09,1.18-2.12,1.72-3.22s1.06-2.18,1.57-3.28c1-2.2,2.08-4.39,3.1-6.59,2.05-4.4,4-8.82,6-13.25,1-2.15,1.89-4.31,2.71-6.52a52.72,52.72,0,0,0,1.87-6.78C286.77,387.42,287.39,382.6,288,377.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,439.93c-2.73,2.45-10.26,9.72-13.47,10.8s-9-.07-9-.07c-6.27,3.25-14.08-1.79-14.08-1.79-2.64-.21-7.2-5.25-7.16-5.73a19.34,19.34,0,0,1,1.39-5.68c1-2.09,8.7-8.38,8.76-9.11,4.67-1.07,9.34-1.54,18.14,1.39a18.4,18.4,0,0,0-10.59-3.07s17.5-1.3,27.86,6C217.33,432.66,218.23,437.49,215.52,439.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.78,433.66a23.31,23.31,0,0,0-3.57,2.84,12.34,12.34,0,0,0-2.71,3.43,10.15,10.15,0,0,0-1.08,4,13.7,13.7,0,0,0,.89,4.81c0,.07.15.06.14,0a19.28,19.28,0,0,1-.06-4.68,10.16,10.16,0,0,1,1.41-3.62,24,24,0,0,1,2.36-3.31c.92-1.08,2-2,2.88-3.12C186.19,433.81,186,433.53,185.78,433.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.24,435.36a22.53,22.53,0,0,0-6.06,6.55,10.55,10.55,0,0,0-.64,8.68.08.08,0,0,0,.15,0,21.47,21.47,0,0,1,.36-4.38,18.49,18.49,0,0,1,1.44-3.79,23.86,23.86,0,0,1,2.13-3.62c.86-1.14,1.77-2.24,2.7-3.32C200.36,435.41,200.3,435.31,200.24,435.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.09,443.9a21.6,21.6,0,0,1-5.66,3.19s-2.57,5.22-6.22,5.8-9-1-9-1-5.11,2.26-8.07,1.68-10.52-6-11.66-8.48-2.31-11-2.31-11c4.41-2.72,14.59-6.42,26.31-4.71,0,0-6.66-.36-11.8,1.62,0,0,9.92-.82,18.21.8l1.77.38.05,0a13.13,13.13,0,0,1,3.1,1.42C276.49,435.27,281,442.12,279.09,443.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.92,443.62c-.56-2.85-3.72-4.08-6.1-5-.09,0-.16.08-.07.13,2.12,1.13,4.59,2.66,4.75,5.35a9.89,9.89,0,0,1-.85,3.85c-.45,1.26-1,2.49-1.41,3.76,0,.09.09.14.15.08a12.13,12.13,0,0,0,2.61-3.65A7.18,7.18,0,0,0,261.92,443.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.22,439c-1.65-2.21-4.74-3-7.28-3.49a.06.06,0,0,0,0,.12c2.35.87,4.76,1.72,6,4.06,1.17,2.17.94,5,.42,7.33a.1.1,0,0,0,.19.07C275,444.75,276,441.43,274.22,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.57,277.51s20.32,5.28,31.5,5,30.14-7,30.14-7-17.89,49.64-28.37,51.87S180.57,277.51,180.57,277.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.56,270.46c-.93.68-1.91,1.28-2.84,2s-1.83,1.38-2.76,2.06c-1.85,1.35-3.74,2.65-5.69,3.87-3.89,2.46-7.85,4.81-11.78,7.21-.06,0-.05.17,0,.14,7-2,13.31-5.8,19.14-10.14.81-.6,1.6-1.21,2.37-1.86s1.56-1.49,2.33-2.24A.65.65,0,0,0,235.56,270.46Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.73,264.45c-2.68,2.47-5,5.29-7.46,7.93-1.24,1.32-2.53,2.6-3.84,3.85s-2.61,2.58-4,3.76c-1.59,1.36-3.27,2.56-4.94,3.81-.06.05,0,.17,0,.14a29.75,29.75,0,0,0,4.79-2.56,49.46,49.46,0,0,0,4.55-3.24,64.94,64.94,0,0,0,7.91-7.91,39.46,39.46,0,0,0,3.84-5.09C243,264.58,242.19,264,241.73,264.45Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,284.84a18.39,18.39,0,0,1-2.54-1c-.79-.33-1.57-.71-2.34-1.09-1.59-.78-3.19-1.51-4.77-2.32a66.26,66.26,0,0,1-9.18-5.36c-.21-.16-.5.11-.29.31a34.75,34.75,0,0,0,8.61,6.6,26.36,26.36,0,0,0,5,2c.88.23,1.76.4,2.64.58s1.88.22,2.79.43A.08.08,0,0,0,211.2,284.84Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,284.82c-3.8-1.7-7.45-3.58-11.09-5.6-1.78-1-3.56-2-5.32-3a24.1,24.1,0,0,1-5.13-3.7c-.13-.13-.33.05-.24.2a16.32,16.32,0,0,0,4.5,4.34,43.2,43.2,0,0,0,5.26,3.44,46.54,46.54,0,0,0,12,4.48C204.49,285,204.55,284.85,204.47,284.82Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41,194.11c-10.12,0-15.22,7.77-15.22,16.85,0,7.35,6,14.86,15.73,14.86s15.73-8.82,15.73-15.73A16,16,0,0,0,181.41,194.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.39,196c-9.52,0-14.31,7.3-14.31,15.83,0,6.91,5.65,14,14.78,14s14.79-8.29,14.79-14.78A15,15,0,0,0,182.39,196Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.49,199.25c-7.45,0-11.2,5.72-11.2,12.4a11.17,11.17,0,0,0,11.57,10.93c7.15,0,11.58-6.49,11.58-11.57A11.75,11.75,0,0,0,182.49,199.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.94,199.37c-3.38,0-5.09,2.6-5.09,5.63a5.08,5.08,0,0,0,5.26,5,5.4,5.4,0,0,0,5.25-5.26A5.33,5.33,0,0,0,185.94,199.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.53,194.11c10.13,0,15.22,7.77,15.22,16.85,0,7.35-6,14.86-15.72,14.86S231.3,217,231.3,210.09A16,16,0,0,1,247.53,194.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,196c9.52,0,14.3,7.3,14.3,15.83,0,6.91-5.64,14-14.78,14S231.3,217.53,231.3,211A15,15,0,0,1,246.56,196Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.46,199.25c7.45,0,11.19,5.72,11.19,12.4a11.17,11.17,0,0,1-11.57,10.93c-7.15,0-11.57-6.49-11.57-11.57A11.75,11.75,0,0,1,246.46,199.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47,199.37c-3.38,0-5.08,2.6-5.08,5.63a5.08,5.08,0,0,0,5.25,5,5.41,5.41,0,0,0,5.26-5.26A5.33,5.33,0,0,0,250.47,199.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.77,215.28c-.14,1-6.48,4.54-7.21,4.54s-7.06-3.58-7.21-4.54,5.72-1.32,7.21-1.32S221.92,214.32,221.77,215.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,223.3a33.05,33.05,0,0,0,4.05,4.06,13.84,13.84,0,0,0,2.3,1.55,4.67,4.67,0,0,0,2.42.6A6.4,6.4,0,0,0,211,227a16.56,16.56,0,0,0,2.62-4.7l1-2.66.94,2.66A19.24,19.24,0,0,0,218,227c1,1.4,2.42,2.58,4,2.46a9.79,9.79,0,0,0,4.79-2.28A32.39,32.39,0,0,0,231,223.3a23.61,23.61,0,0,1-3.57,4.56,13.52,13.52,0,0,1-2.3,1.87,7.24,7.24,0,0,1-2.89,1.16,5.12,5.12,0,0,1-3.25-.63,9,9,0,0,1-2.38-2.08,14.41,14.41,0,0,1-1.69-2.52,22.16,22.16,0,0,1-1.25-2.75h1.89a18.1,18.1,0,0,1-1.32,2.77,13.58,13.58,0,0,1-1.8,2.49,9.62,9.62,0,0,1-2.48,2,6.57,6.57,0,0,1-3.14.77,5.72,5.72,0,0,1-3-1,12.72,12.72,0,0,1-2.3-1.93A23.46,23.46,0,0,1,198,223.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.63,221.82c-7.1-1.8-14.26-3.32-21.46-4.66s-14.41-2.54-21.67-3.44q-2.72-.39-5.44-.69c-1.82-.21-3.63-.45-5.45-.63-3.64-.34-7.28-.7-10.93-1-7.3-.63-14.61-.85-21.94-1.1l5.5-.08c1.83,0,3.67,0,5.5,0l5.49.14c1.84,0,3.67.18,5.5.27,7.32.38,14.62,1.14,21.9,2.06s14.51,2.19,21.69,3.68q5.38,1.13,10.73,2.44C158.59,219.77,162.14,220.7,165.63,221.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,225.55c-3.28-.42-6.55-.82-9.84-1.15s-6.56-.68-9.85-1c-6.57-.58-13.15-1.07-19.74-1.36-3.29-.21-6.59-.31-9.88-.43s-6.6-.16-9.89-.17l-4.95,0-5,.08c-3.3,0-6.59.21-9.9.25,6.58-.6,13.18-1,19.79-1.07s13.23.06,19.83.37,13.2.85,19.77,1.59S155.53,224.3,162,225.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.22,229.93c-2.75,0-5.5,0-8.25,0s-5.5.07-8.25.16c-5.5.16-11,.34-16.48.7s-11,.69-16.45,1.17-10.94,1-16.43,1.57q4.08-.71,8.16-1.31c2.73-.36,5.46-.73,8.2-1,5.47-.64,11-1,16.47-1.4s11-.47,16.52-.47S157.73,229.46,163.22,229.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.73,221.82c3.49-1.12,7-2,10.58-3s7.14-1.69,10.73-2.44c7.18-1.49,14.42-2.69,21.69-3.68s14.57-1.68,21.9-2.06c1.83-.09,3.66-.22,5.49-.27l5.5-.14c1.83,0,3.67,0,5.5,0l5.49.08c-7.32.25-14.64.47-21.93,1.1-3.65.26-7.29.62-10.93,1-1.82.18-3.63.42-5.45.63s-3.63.43-5.44.69c-7.26.9-14.48,2.11-21.67,3.44S272.83,220,265.73,221.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.34,225.55c6.49-1.25,13-2.14,19.61-2.88s13.17-1.22,19.77-1.59,13.21-.47,19.82-.37,13.22.47,19.8,1.07c-3.31,0-6.6-.27-9.9-.25l-4.95-.08-4.95,0c-3.3,0-6.59.11-9.89.17s-6.59.22-9.88.43c-6.59.29-13.17.78-19.74,1.36q-4.93.42-9.85,1C275.89,224.73,272.62,225.13,269.34,225.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,229.93c5.49-.47,11-.59,16.51-.6s11,.19,16.52.47,11,.76,16.47,1.4c2.74.3,5.47.67,8.2,1s5.44.84,8.15,1.31c-5.48-.54-10.94-1.13-16.43-1.57s-11-.88-16.45-1.17-11-.54-16.47-.7c-2.75-.09-5.5-.13-8.25-.16S270.89,229.91,268.14,229.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,361.44s.75,14.32.8,16.12c0,0,6.78,5.58,5.25,8.38-1.17,2.13-6.13,5.31-35.88.63s-66.51-2.62-68.68,22.08,24.7,36.05,65.44,34.61,68.14-16,68.86-41.64C389.32,382.63,370.13,365,353,361.44Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.66,393.34a32.27,32.27,0,0,0-4.1-7.29c-.06-.08-.18,0-.13.07a23.89,23.89,0,0,1,2.9,6.75,50.77,50.77,0,0,1,1.18,7.15,38.44,38.44,0,0,1-.58,11.2c-.26,1.28-.63,2.53-.91,3.81a53.3,53.3,0,0,1-2.58,8.4c-.15.37.45.61.63.27a49.13,49.13,0,0,0,3.42-7.36,38.58,38.58,0,0,0,1.77-7.88A29.7,29.7,0,0,0,388.66,393.34Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.57,399.11a.07.07,0,1,0-.14,0,32.58,32.58,0,0,1-.79,7c-.47,2.28-1,4.56-1.6,6.81a50.37,50.37,0,0,1-2.25,6.64c-.44,1.05-.92,2.08-1.43,3.1s-1,2.16-1.56,3.2-1.3,2.29-2,3.43-1.45,2.19-2.19,3.27c-.14.21.17.44.35.27a38,38,0,0,0,4.6-5.45,35.83,35.83,0,0,0,3.56-6.26,39.63,39.63,0,0,0,3.64-13.95C387.92,404.5,387.72,401.81,387.57,399.11Z",
    style: {
      fill: "#FAC018"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.49,379.73c-2.06,4.14-6.2,6.83-10.56,8-5.5,1.55-11.28.75-16.83-.13-5.89-.94-11.8-1.76-17.71-2.52-5.64-.72-11.29-1.43-17-1.84-11-.8-22.52-.42-32.95,3.67A30.05,30.05,0,0,0,259,395.61a26.56,26.56,0,0,0-5.77,12.64,23.74,23.74,0,0,0,10,23.22,22.5,22.5,0,0,0,2.86,1.64.09.09,0,0,0,.08-.15c-7.33-5.37-12.67-13.66-11.64-22.58a25.24,25.24,0,0,1,5.23-12.5,27.89,27.89,0,0,1,11.59-8.55c10.13-4.21,21.36-4.67,32.17-4,11.42.75,22.76,2.61,34.11,4,5.58.69,11.39,1.29,16.92,0a18.34,18.34,0,0,0,10.73-6.7,13.76,13.76,0,0,0,1.51-2.77C366.82,379.7,366.58,379.55,366.49,379.73Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc223093fe64f504cd42c9e410122597.svg";
export { ForwardRef as ReactComponent };